import createElement from '../../utils/create_element';
import Episode from './episode';

export default class EpisodePanel {
  constructor({ data } = {}) {
    this.cache = {};
    this._data = data;
  }

  data() {
    return this._data;
  }

  episodePanel() {
    return this._episodePanel;
  }

  episodeList() {
    return this._episodeList;
  }

  setContent(content) {
    this.episodeList().innerHTML = content;
  }

  setSeasonName(name) {
    this._header.querySelector('b').innerHTML = name;
  }

  addEpisode(episode) {
    this.episodeList().appendChild(episode);
  }

  setScrollPosition(position) {
    this.episodeList().scrollTop = position;
  }

  show() {
    this.episodePanel().classList.add('active');
  }

  hide() {
    this.episodePanel().classList.remove('active');
  }

  createCloseButton() {
    const button = createElement(`
      <button class="episode-chooser-episode-button-close">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path fill="#1E1E1E" fill-rule="evenodd" d="M1.623 12.82a1.2 1.2 0 0 1 0-1.697l8.278-8.278a1.2 1.2 0 1 1 1.697 1.697l-7.43 7.43 7.43 7.43a1.2 1.2 0 1 1-1.697 1.697L1.623 12.82Z" clip-rule="evenodd"/><path fill="#1E1E1E" fill-rule="evenodd" d="M1.328 11.972a1.2 1.2 0 0 1 1.2-1.2h19a1.2 1.2 0 0 1 0 2.4h-19a1.2 1.2 0 0 1-1.2-1.2Z" clip-rule="evenodd"/></svg>
      </button>
    `);
    button.onclick = () => {
      this.hide();
    };

    return button;
  }

  createHeader() {
    return createElement(`
      <div class="episode-chooser-episode-header">
        <b></b>
      </div>
    `);
  }

  createEpisodeList() {
    return createElement(`<ul class="episode-chooser-episode-list"></ul>`);
  }

  dom() {
    this._episodePanel = createElement(`<div class="episode-chooser-episode"></div>`);
    this._closeButton = this.createCloseButton();
    this._header = this.createHeader();
    this._episodeList = this.createEpisodeList();

    this._header.prepend(this._closeButton);
    this._episodePanel.append(this._header);
    this._episodePanel.append(this._episodeList);

    return this._episodePanel;
  }

  fetchEpisodesFromSeason(season_id) {
    return new Promise((resolve, reject) => {
      return fetch(`/seasons/${season_id}`)
        .then(response => response.json())
        .then(data => data.season)
        .then(resolve)
        .catch(reject);
    });
  }

  showEpisodeFromSeason(season) {
    this.setSeasonName(season.name);
    this.setScrollPosition(0);
    this.setContent('');

    if (this.cache[season.id]) {
      this.setEpisodes(this.cache[season.id]);
    } else {
      this.fetchEpisodesFromSeason(season.id).then((episodes) => {
        this.cache[season.id] = episodes;
        this.setEpisodes(episodes);
      });
    }
  }

  setEpisodes(episodes) {
    let isCurrentEpisode = false;

    episodes.forEach((episode) => {
      if (episode.title === this.data().videoTitle()) {
        isCurrentEpisode = true;
      }
      const child = new Episode({ episode, isCurrentEpisode, data: this.data() });
      this.addEpisode(child.dom());
    });
    this.show();
    this.shouldScrollToCurrentEpisode(isCurrentEpisode);
  }

  scrollToCurrentEpisode() {
    const current_episode = document.querySelector('.episode-chooser-episode-list-item.current');
    const parent_element = current_episode.parentElement;
    const position = current_episode.getBoundingClientRect().y - parent_element.getBoundingClientRect().y;
    this.setScrollPosition(position);
  }

  shouldScrollToCurrentEpisode(value) {
    if (value === true) {
      this.scrollToCurrentEpisode();
    } else {
      this.setScrollPosition(0);
    }
  }
}
